//全局常量
// export const BASE_URL = "http://zhonglian.meitituiguang.com:8089"
// export const BASE_URL = "http://127.0.0.1:8089"
// export const PIC_URL = "http://zhonglian1.meitituiguang.com"
export const BASE_URL = ""
export const PIC_URL = ""
